import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  // Convocatoria a la que se acota el listado (id del catálogo), o null para
  // "todos los aspirantes". Con una convocatoria activa el listado se arma desde
  // las postulaciones (applications), no desde la colección plana.
  callId: null,
  // Estado de documentación: PENDING | INCOMPLETE | COMPLETE | VALIDATED.
  documentationStatus: null,
  // % de completitud mínimo (number) o null para no filtrar.
  minCompletion: null,
  // ISO yyyy-mm-dd bounds on createdAt. Null means no bound on that side.
  dateFrom: null,
  dateTo: null,
};

export const applicantSlice = createSlice({
  name: "applicant",
  initialState: {
    list: [],
    loading: false,
    filters: initialFilters,
    current: null,
  },
  reducers: {
    setApplicantLoading: (state, action) => {
      state.loading = !!action.payload;
    },
    setApplicantList: (state, action) => {
      state.list = action.payload || [];
      state.loading = false;
    },
    // Cursor-paginated cascade: append the next page, de-duped by nuip (the doc id).
    appendApplicantList: (state, action) => {
      const incoming = action.payload || [];
      if (!incoming.length) return;
      const seen = new Set(state.list.map((a) => a.nuip));
      for (const item of incoming) {
        if (!seen.has(item.nuip)) {
          state.list.push(item);
          seen.add(item.nuip);
        }
      }
    },
    setApplicantFilters: (state, action) => {
      state.filters = { ...state.filters, ...(action.payload || {}) };
    },
    resetApplicantFilters: (state) => {
      state.filters = initialFilters;
    },
    setCurrentApplicant: (state, action) => {
      state.current = action.payload || null;
    },
  },
});

export const {
  setApplicantLoading,
  setApplicantList,
  appendApplicantList,
  setApplicantFilters,
  resetApplicantFilters,
  setCurrentApplicant,
} = applicantSlice.actions;

export default applicantSlice.reducer;
